import i18next from 'i18next'
import z from 'zod'

import { kWordsAvailabilities } from 'features/inventory/domain/types/kWordsAvailability'
import { matchTypeValues } from 'features/inventory/page/types/matchType'

import type { Domain } from 'features/inventory/types/domain'

export const schema = z
  .object({
    availability: z.enum(kWordsAvailabilities).default('notAvailable').optional(),
    customVariableName: z.string().optional(),
    customVariableTriggerEnabled: z.boolean().default(false),
    customVariableValue: z.string().optional(),
    enabled: z.boolean().default(false),
    kwordsSiteId: z.string().default(''),
    matchType: z.enum(matchTypeValues).default('include'),
    overrideWorkspaceDefaults: z.boolean().default(false).optional(),
    path: z.string().optional(),
    pathTriggerEnabled: z.boolean().default(false),
  })
  .superRefine((data: Schema, ctx: z.RefinementCtx): void => {
    const { customVariableName, customVariableTriggerEnabled, customVariableValue } = data

    if (customVariableTriggerEnabled === true) {
      if (customVariableName === undefined || customVariableName.length === 0) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            'features/domain:form.richPlacements.kWords.triggers.customVariableName.requiredError',
          ),
          path: ['customVariableName'],
        })
      }

      if (customVariableValue === undefined || customVariableValue.length === 0) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            'features/domain:form.richPlacements.kWords.triggers.customVariableValue.requiredError',
          ),
          path: ['customVariableValue'],
        })
      }
    }
  })

export type Schema = z.infer<typeof schema>

export const schemaDefault = (domain: Domain): Schema => {
  const {
    domainRichPlacementKWords: {
      availability,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      enabled,
      kwordsSiteId,
      matchType,
      overrideWorkspaceDefaults,
      path,
      pathTriggerEnabled,
    },
  } = domain

  return {
    availability,
    customVariableName,
    customVariableTriggerEnabled,
    customVariableValue,
    enabled,
    kwordsSiteId: kwordsSiteId ?? '',
    matchType,
    overrideWorkspaceDefaults,
    path,
    pathTriggerEnabled,
  }
}
